import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export interface TrailingNodeOptions {
	node: string;
	wrapAround: string[];
	wrapperOptions: string[];
}

export const TextAround = Extension.create<TrailingNodeOptions>({
	name: 'textAround',

	addOptions() {
		return {
			node: 'paragraph',
			wrapAround: [
				'hubsLinkComponent',
				'hubsImageComponent',
				'hubsDocumentComponent',
				'hubsGalleryComponent',
				'hubsWidgetComponent',
				'hubsCustomHtmlComponent',
				'hubsQuickPollComponent',
			],
			wrapperOptions: ['paragraph', 'heading'],
		};
	},

	addProseMirrorPlugins() {
		const plugin = new PluginKey(this.name);

		return [
			new Plugin({
				key: plugin,
				appendTransaction: (_, __, state) => {
					const { doc, tr, schema } = state;

					let previousNodeName: null | string = null;

					// Hack to 'stop' the loop, We need the position of the nodes, so we can't use a 'normal' for loop
					let stop = false;

					doc.descendants((node, pos, parent) => {
						const parentNodeName = parent?.type.name;

						// Only run this on the top level nodes and check if we should stop
						if (stop || parentNodeName != 'doc') return;

						// Get the node name at the current index
						const nodeName = node.type.name;

						// If the node name is not in the list of nodes to wrap around, skip it
						const shouldBeWrapped = this.options.wrapAround.includes(nodeName);
						if (!shouldBeWrapped) {
							previousNodeName = nodeName;
							return;
						}

						// Is the previous node a "wrapper" node?
						const isPrevWrapperNode =
							previousNodeName && this.options.wrapperOptions.includes(previousNodeName);

						// Get the next node
						let nextNodeName: string | undefined;
						try {
							nextNodeName = tr.doc.nodeAt(pos + node.nodeSize)?.type.name;
						} catch {
							// Do nothing
						}
						// Is the next node a "wrapper" node?
						const isNextWrapperNode =
							nextNodeName && this.options.wrapperOptions.includes(nextNodeName);

						if (!isNextWrapperNode) {
							tr.insert(pos + node.nodeSize, schema.nodes.paragraph.create());
							stop = true;
						}

						if (!isPrevWrapperNode) {
							tr.insert(pos, schema.nodes.paragraph.create());
							stop = true;
						}
						previousNodeName = nodeName;
					});
					return tr;
				},
			}),
		];
	},
});
